import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Close, Division, LangEmployee, LangExportExcelSendTo, LangFilterGroup, LangProcess, LangRequestSuccess, LangTargetCount } from '../../constant/languange'
import { axiosCompany, mapStateToProps, SpinnerButton } from '../../helpers/Common'

function PersonnelExportComponent({ redux, onClose, ...props }) {
  const [data, setData] = useState({
    group_id: '',
    target_count: 0,
    send_to: redux.profile?.email ?? '',
  })
  const [errors, setError] = useState({ fields: [], message: '' })
  const [control, setControl] = useState({ showSuccessAlert: false, showLoad: false })

  useEffect(() => {
    getPersonnelsService()
    // eslint-disable-next-line
  }, [])

  const getExportService = () => {
    setControl({ ...control, showLoad: true, alertSuccess: false })
    axiosCompany().post('personnels/export-v2', data).then(ress => {
      // const nameFile = `personnel-${data.group_id !== '' ? redux.groups.find((item) => +item.id === +data.group_id).name.toLowerCase() : 'all'}`
      // axiosDownloadFile(ress.data, nameFile, 'xlsx')
      if (ress.data.success) {
        setControl(control => ({ ...control, alertSuccess: true, showLoad: false }))
        setError({ fields: [], message: '' })
      } else {
        setControl(control => ({ ...control, showLoad: false }))
        setError({ fields: [], message: ress.data?.message ?? '' })
      }
      // setControl({ ...control, showSuccessAlert: true, showLoad: false })
    }).catch(e => {
      setError(error => {
        error.fields = e.response.data.errors ? e.response.data.errors : { 0: [e.response.statusText] }
        error.message = e.response.data.message ? e.response.data.message : ''
        return { ...error }
      })
      setControl(control => ({ ...control, showLoad: false }))
    })
  }

  const getPersonnelsService = () => {
    setControl({ ...control, showLoad: true })
    axiosCompany().get('personnels?', { params: { group_id: data.group_id } }).then((ress) => {
      setData(data => {
        data.target_count = ress.data?.meta?.total
        return { ...data }
      })
      setControl({ ...control, showLoad: false })
    }).catch(e => {
      setControl({ ...control, showLoad: false })
    })
  }

  const handleSelectChange = (e) => {
    setData({ ...data, group_id: e.target.value })
    data.group_id = e.target.value
    getPersonnelsService()
  }

  const handleExport = () => {
    getExportService()
  }

  return (
    <>
      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>{LangFilterGroup}</label>
        <div className='col-sm-5'>
          <select className='form-control' value={data.group_id} onChange={(e) => { handleSelectChange(e) }}>
            <option value=''>--{Division}--</option>
            {redux.groups.map((obj) => {
              return (
                <option key={obj.id} value={obj.id}>{obj.name}</option>
              )
            })}
          </select>
        </div>
      </div>
      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>{LangTargetCount}</label>
        <div className='col-sm-9 pt-1'>
          {data.target_count} {LangEmployee}
        </div>
      </div>
      <div className='form-group row'>
        <label className='col-sm-3 col-form-label'>{LangExportExcelSendTo} <span className='txt-danger'>*</span></label>
        <div className='col-sm-9'>
          <input className={`form-control ${errors.fields.send_to ? 'is-invalid' : ''}`} value={data.send_to} type='text' title='' onChange={(e) => { setData({ ...data, send_to: e.target.value }) }} />
          {errors.fields.send_to ? (<p className='my-0 font-danger' style={{ fontSize: '80%' }}>{errors.fields.send_to[0]}</p>) : (null)}
        </div>
      </div>
      <hr />
      <div className='form-group row'>
        <div className='col-9 offset-3'>
          {errors.message ? <div className='alert alert-danger'> <p style={{ textAlign: 'center' }}>{errors.message}</p></div> : null}
          {control.alertSuccess ? <div className='alert alert-success'> <p className='mb-0'>{LangRequestSuccess}</p></div> : null}

          <button disabled={control.showLoad} className='btn  btn-primary mr-2' onClick={handleExport}> {(control.showLoad) ? SpinnerButton : ''} {LangProcess}</button>
          <button disabled={control.showLoad} className='btn  btn-light' type='button' onClick={() => { onClose() }}>
            {Close}
          </button>

        </div>
      </div>
    </>

  )
}

export default connect(mapStateToProps)(PersonnelExportComponent)
